<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('neolinks')"
      :columns="columns"
      :column_search="true"
      resource_url="/neolink/request/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/neolink/settings' })"
        >
          <span class="icon"><i class="fa fa-users"></i></span>
          <span>{{ $t("profiles") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <request-modal ref="request_modal" @success="refresh" />
    <log-modal ref="log_modal" />
    <detail-modal ref="detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
} from "@/utils";
import RequestModal from "./request_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import DetailModal from "./detail_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "SIRCRequestsDatatable",
  components: { GenericTable, RequestModal, LogModal, DetailModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("customer"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${
              row.settings.dpi || ""
            }</div><div class="subtitle is-6">${
              row.settings.first_name || ""
            } ${row.settings.first_surname || ""}</div>`;
            // return `<div class="is-flex">
            //   <div class="is-flex-grow-1">${row.settings.first_name || ""}</div>
            //   <div class="is-flex-grow-1">${
            //     row.settings.first_surname || ""
            //   }</div>
            //   <div class="is-flex-grow-1">${row.settings.dpi || ""}</div>
            //   </div>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          // width: "30%",
          data: (row) => {
            return v.translate_status(row.status_code);
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "55%",
        //   data: (row) => {
        //     // return truncate(JSON.stringify(row), { length: 65 });
        //     return `<pre>${JSON.stringify(row)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.log_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.detail_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete request?"),
                    v,
                    () => {
                      del("/neolink/request", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.request_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status) {
      let v = this;
      switch (status) {
        case "C":
          return v.$t("created");
        case "E":
          return v.$t("errored");
        case "T":
          return v.$t("token retrieved");
        case "D":
          return v.$t("data retrieved");
        default:
          return status;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
